import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { AppService } from 'src/app/shared/service/app.service';
import { TranslateModule } from '@ngx-translate/core';
import { NgScrollbarModule, provideScrollbarOptions } from 'ngx-scrollbar';
import { NgSelectModule } from '@ng-select/ng-select';
import { MenuModule } from 'headlessui-angular';
import { DataTableModule } from '@bhplugin/ng-datatable';
import { FullCalendarModule } from '@fullcalendar/angular';
import { IconModule } from 'src/app/shared/icon/icon.module';
import { NgxCustomModalComponent } from 'ngx-custom-modal';
// apexchart
import { NgApexchartsModule } from 'ng-apexcharts';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        DataTableModule,
        ReactiveFormsModule,
        RouterModule,
        TranslateModule.forChild(),
        NgScrollbarModule,
        MenuModule,
        NgSelectModule,
        NgxCustomModalComponent,
        FullCalendarModule,
        IconModule,
        NgApexchartsModule,
    ],
    declarations: [],
    exports: [
        FormsModule,
        NgSelectModule,
        ReactiveFormsModule,
        RouterModule,
        TranslateModule,
        NgScrollbarModule,
        MenuModule,
        DataTableModule,
        IconModule,
        FullCalendarModule,
        NgxCustomModalComponent,
        NgApexchartsModule,
    ],
})
export class SharedModule {
    static forRoot(): ModuleWithProviders<any> {
        return {
            ngModule: SharedModule,
            providers: [
                Title,
                AppService,
                provideScrollbarOptions({
                    visibility: 'hover',
                    appearance: 'compact',
                }),
            ],
        };
    }
}
